import { RouteObject } from "react-router-dom";

import { privateLoader, ownerLoader, adminLoader } from "../loaders";
import { managementRoutes } from "@modules/management";
import { adminRoutes } from "@modules/admin";
import {
  HomePage,
  LoadingScreen,
  MainPage,
  RoadmapPage,
} from "@shared/components";
import { buildOperationalModuleRoutes } from "./operationalModuleRoutes";

export const privateRoutes: RouteObject[] = [
  {
    path: "management",
    element: <MainPage />,
    loader: async (args) => {
      await privateLoader(args);
      return ownerLoader();
    },
    HydrateFallback: LoadingScreen,
    children: managementRoutes,
  },
  {
    path: "admin",
    element: <MainPage />,
    loader: async (args) => {
      await privateLoader(args);
      return adminLoader();
    },
    HydrateFallback: LoadingScreen,
    children: adminRoutes,
  },
  {
    path: "/",
    element: <MainPage />,
    children: [
      {
        index: true,
        loader: privateLoader,
        element: <HomePage />,
        HydrateFallback: LoadingScreen,
      },
    ],
  },
  {
    path: "/roadmap",
    element: <MainPage hideSidebar />,
    children: [
      {
        index: true,
        loader: async (args) => {
          await privateLoader(args);
          return ownerLoader();
        },
        element: <RoadmapPage />,
        HydrateFallback: LoadingScreen,
      },
    ],
  },
  // Módulos operacionais (fatia 3): cada módulo canônico vira /<slug>, com seletor
  // de estrutura no índice e /<slug>/:structureId guardado pelo loader operacional.
  // `privateLoader` garante a sessão; o gate de publicação/autorização vive no
  // loader de cada rota (operationalModuleLoader).
  {
    path: "/",
    element: <MainPage />,
    loader: privateLoader,
    HydrateFallback: LoadingScreen,
    children: buildOperationalModuleRoutes(),
  },
  {
    path: "/loadingTest",
    element: <MainPage />,
    children: [
      {
        path: "general",
        loader: privateLoader,
        element: <LoadingScreen />,
      },
    ],
  },
];
